import React from "react";
import { connect } from "react-redux";
import BreadCrumComponent from "../../componentes/BreadCrumComponent";
import PantallaCarga from "../../mensajeFlash/PantallaCarga";
import MensajeFlash from "../../mensajeFlash/MensajeFlash";

import {
  obtenerCabeceraLegajo,
  obtenerDatosPersonales,
  guardarDatosPersonales,
  getDiasLaborales,
  setDiasLaborales,

  getTelefonos, registrarTelefono, editarTelefono, eliminarTelefono,
  getCorreos, registrarCorreo, editarCorreo, eliminarCorreo,
  getRedes, registrarRed, editarRed, eliminarRed,
  getDocumentos, registrarDocumento, editarDocumento, eliminarDocumento,
  getAcademicos, registrarAcademico, editarAcademico, eliminarAcademico,
  getCapacitaciones, registrarCapacitacion, editarCapacitacion, eliminarCapacitacion,
  getExperiencias, registrarExperiencia, editarExperiencia, eliminarExperiencia,
  getCargos, registrarCargo, editarCargo, eliminarCargo,
  getEvaluaciones, registrarEvaluacion, editarEvaluacion, eliminarEvaluacion,descargarLegajoFile
} from "./LegajoService";

class EditarLegajo extends React.Component {
  constructor(props) {
    super(props);

    const legajoId =
      props?.location?.state?.legajo?.legajoId ||
      props?.location?.state?.legajo?.id ||
      props?.match?.params?.legajoId ||
      props?.match?.params?.id ||
      "";

    this.state = {
      legajoId,

      tab: "DATOS_PERSONALES", // default

      // cabecera (LegajoDetalleDTO)
      cabecera: null,

      // datos personales (LegajoDatosPersonalesDTO)
      datosPersonales: {
        fechaNacimiento: "",
        sexo: "",
        estadoCivil: "",
        nacionalidad: "",
        direccion: "",
        ciudadDireccion: "",
        paisDireccion: "",
        codigoInterno: "",
        esConfidencial: false,
      },

      // listas por sección
      telefonos: [],
      correos: [],
      redes: [],
      documentos: [],
      academicos: [],
      capacitaciones: [],
      experiencias: [],
      cargos: [],
      evaluaciones: [],

      diasLaboralesMask: 31, // lunes-viernes por defecto

      // ui
      cargando: true,
      guardando: false,

      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "neutral",
    };
  }

  componentDidMount() {
    this.cargarTodo();
  }

  // =========================
  // Carga inicial
  // =========================
  cargarTodo = async () => {
    try {
      this.setState({ cargando: true });

      const { legajoId } = this.state;
      if (!legajoId) throw new Error("No llegó legajoId");

      const [
        cab,
        dp,
        tels,
        cors,
        reds,
        docs,
        acads,
        caps,
        exps,
        cars,
        evals,
        diasLaboralesRes,
      ] = await Promise.all([
        this.props.obtenerCabeceraLegajo(legajoId),
        this.props.obtenerDatosPersonales(legajoId),

        this.props.getTelefonos(legajoId),
        this.props.getCorreos(legajoId),
        this.props.getRedes(legajoId),
        this.props.getDocumentos(legajoId),
        this.props.getAcademicos(legajoId),
        this.props.getCapacitaciones(legajoId),
        this.props.getExperiencias(legajoId),
        this.props.getCargos(legajoId),
        this.props.getEvaluaciones(legajoId),
        getDiasLaborales(legajoId).catch(() => ({ data: 31 })),
      ]);

      const cabecera = cab?.datos || null;
      const datosPersonales = dp?.datos || {};

      this.setState({
        cargando: false,
        cabecera,
        datosPersonales: {
          fechaNacimiento: this.toInputDate(datosPersonales.fechaNacimiento),
          sexo: datosPersonales.sexo || "",
          estadoCivil: datosPersonales.estadoCivil || "",
          nacionalidad: datosPersonales.nacionalidad || "",
          direccion: datosPersonales.direccion || "",
          ciudadDireccion: datosPersonales.ciudadDireccion || "",
          paisDireccion: datosPersonales.paisDireccion || "",
          codigoInterno: datosPersonales.codigoInterno || "",
          esConfidencial: !!datosPersonales.esConfidencial,
        },

        telefonos: (tels?.datos || tels || []),
        correos: (cors?.datos || cors || []),
        redes: (reds?.datos || reds || []),
        documentos: (docs?.datos || docs || []),
        academicos: (acads?.datos || acads || []),
        capacitaciones: (caps?.datos || caps || []),
        experiencias: (exps?.datos || exps || []),
        cargos: (cars?.datos || cars || []),
        evaluaciones: (evals?.datos || evals || []),
        diasLaboralesMask: diasLaboralesRes?.data ?? 31,
      });
    } catch (e) {
      this.setState({
        cargando: false,
        mostrarMensajeFlash: true,
        mensajeFlash: "No se pudo cargar el legajo completo.",
        mensajeFlashSeverity: "error",
      });
    }
  };

  flash = (mensaje, severity) =>
    this.setState({ mostrarMensajeFlash: true, mensajeFlash: mensaje, mensajeFlashSeverity: severity });

  // Convierte lo que venga del backend a yyyy-mm-dd para input date
  toInputDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  // =========================
  // Tabs
  // =========================
  setTab = (tab) => this.setState({ tab });

  // =========================
  // Datos personales
  // =========================
  handleDP = (e) => {
    const { name, type, value, checked } = e.target;
    this.setState((prev) => ({
      datosPersonales: {
        ...prev.datosPersonales,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };

  guardarDP = async () => {
    const { legajoId, datosPersonales } = this.state;

    try {
      this.setState({ guardando: true });

      const dto = {
        ...datosPersonales,
        fechaNacimiento: datosPersonales.fechaNacimiento || null,
      };

      const res = await this.props.guardarDatosPersonales(legajoId, dto);

      this.setState({
        guardando: false,
        mostrarMensajeFlash: true,
        mensajeFlash: res?.mensaje || "Datos personales guardados.",
        mensajeFlashSeverity: res?.error ? "error" : "exito",
      });
    } catch (e) {
      this.setState({
        guardando: false,
        mostrarMensajeFlash: true,
        mensajeFlash: "No se pudieron guardar los datos personales.",
        mensajeFlashSeverity: "error",
      });
    }
  };

  // =========================
  // Helpers CRUD inline (secciones)
  // =========================
  updateRowField = (sectionKey, idx, field, value) => {
    this.setState((prev) => {
      const copy = [...prev[sectionKey]];
      copy[idx] = { ...copy[idx], [field]: value, __dirty: true };
      return { [sectionKey]: copy };
    });
  };

  addRow = (sectionKey, emptyFactory) => {
    this.setState((prev) => ({
      [sectionKey]: [...prev[sectionKey], { ...emptyFactory(), __isNew: true, __dirty: true }],
    }));
  };

  removeRowLocal = (sectionKey, idx) => {
    this.setState((prev) => {
      const copy = [...prev[sectionKey]];
      copy.splice(idx, 1);
      return { [sectionKey]: copy };
    });
  };

  downloadFile = async (fileId, fallbackName = "archivo") => {
  try {
    const res = await this.props.descargarLegajoFile(fileId);

    const blob = new Blob([res.data], { type: res.headers["content-type"] || "application/octet-stream" });

    // nombre desde header si viene
    const cd = res.headers["content-disposition"] || "";
    const match = cd.match(/filename="(.+?)"/);
    const filename = match?.[1] || fallbackName;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: "No se pudo descargar el archivo.",
      mensajeFlashSeverity: "error",
    });
  }
};


saveRow = async (sectionKey, row, handlers) => {
  const { legajoId } = this.state;
  const { createFn, updateFn, reloadFn } = handlers;

  const seccionConArchivo = ["documentos", "academicos", "capacitaciones"].includes(sectionKey);
  const tieneArchivo = !!row.__file;

  try {
    this.setState({ guardando: true });

    let res;

    // ✅ multipart (solo si la sección permite archivo y el usuario seleccionó uno)
    if (seccionConArchivo && tieneArchivo) {
      const formData = new FormData();
      formData.append(
        "payload",
        new Blob([JSON.stringify(this.stripMeta(row))], { type: "application/json" })
      );
      formData.append("archivo", row.__file);

      if (row.id) {
        // Documentos necesita flag true, académicos/capacitaciones no
        if (sectionKey === "documentos") res = await updateFn(legajoId, row.id, formData, true);
        else res = await updateFn(legajoId, row.id, formData);
      } else {
        if (sectionKey === "documentos") res = await createFn(legajoId, formData, true);
        else res = await createFn(legajoId, formData);
      }

      // limpiar file local
      row.__file = null;
      row.__preview = null;
    } else {
      // ✅ JSON normal
      if (row.id) res = await updateFn(legajoId, row.id, this.stripMeta(row));
      else res = await createFn(legajoId, this.stripMeta(row));
    }

    // recargar sección
    const reloaded = await reloadFn(legajoId);
    const list = (reloaded?.datos || reloaded || []);

    this.setState({
      guardando: false,
      [sectionKey]: list,
      mostrarMensajeFlash: true,
      mensajeFlash: res?.mensaje || "Guardado correctamente.",
      mensajeFlashSeverity: res?.error ? "error" : "exito",
    });
  } catch (e) {
    this.setState({
      guardando: false,
      mostrarMensajeFlash: true,
      mensajeFlash: "No se pudo guardar el registro.",
      mensajeFlashSeverity: "error",
    });
  }
};



onSelectArchivo = (sectionKey, idx, file) => {
  if (!file) return;

  this.setState(prev => {
    const copy = [...prev[sectionKey]];
    const row = { ...copy[idx] };

    row.__file = file;
    row.__preview = file.type?.startsWith("image/") ? URL.createObjectURL(file) : null;

    copy[idx] = row;
    return { [sectionKey]: copy };
  });
};



  deleteRow = async (sectionKey, row, handlers) => {
    const { legajoId } = this.state;
    const { deleteFn, reloadFn } = handlers;

    // si aún no existe en BD, lo saco local
    if (!row.id) {
      const idx = this.state[sectionKey].indexOf(row);
      if (idx >= 0) this.removeRowLocal(sectionKey, idx);
      return;
    }

    try {
      this.setState({ guardando: true });

      const res = await deleteFn(legajoId, row.id);

      const reloaded = await reloadFn(legajoId);
      const list = (reloaded?.datos || reloaded || []);

      this.setState({
        guardando: false,
        [sectionKey]: list,
        mostrarMensajeFlash: true,
        mensajeFlash: res?.mensaje || "Eliminado.",
        mensajeFlashSeverity: res?.error ? "error" : "exito",
      });
    } catch (e) {
      this.setState({
        guardando: false,
        mostrarMensajeFlash: true,
        mensajeFlash: "No se pudo eliminar.",
        mensajeFlashSeverity: "error",
      });
    }
  };
  onSelectImagen = (sectionKey, row, file) => {
  if (!file) return;


  const maxMB = 5;
  if (file.size > maxMB * 1024 * 1024) {
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: `La imagen supera ${maxMB}MB`,
      mensajeFlashSeverity: "error",
    });
    return;
  }


  const previewUrl = URL.createObjectURL(file);


  row.imagenFile = file;
  row.imagenPreview = previewUrl;

  this.setState({ ...this.state });
};


stripMeta = (row) => {
  const { __dirty, __isNew, __file, __preview, ...clean } = row || {};
  return clean;
};

  // =========================
  // Render Cabecera
  // =========================
 renderCabecera = () => {
  const c = this.state.cabecera;
  if (!c) return null;

  return (
    <div className="card mb-2">
      <h3 className="card-title">Cabecera</h3>

      <div className="cabecera-grid">
        {/* Columna 1: hasta Username */}
        <div className="cabecera-col">
          <div className="card-info">
            <span className="label">Legajo ID</span>
            <span className="txt">{c.legajoId}</span>
          </div>

          <div className="card-info">
            <span className="label">Miembro / Empresa</span>
            <span className="txt">
              Miembro #{c.miembroId} — Empresa #{c.empresaId}
            </span>
          </div>

          <div className="card-info">
            <span className="label">Nombre</span>
            <span className="txt">{c.nombre} {c.apellido}</span>
          </div>

          <div className="card-info">
            <span className="label">Username</span>
            <span className="txt">{c.username}</span>
          </div>
        </div>

        {/* Columna 2: resto */}
        <div className="cabecera-col">
          <div className="card-info">
            <span className="label">Correo</span>
            <span className="txt">{c.correo}</span>
          </div>

          <div className="card-info">
            <span className="label">Cédula</span>
            <span className="txt">{c.cedula}</span>
          </div>

          <div className="card-info">
            <span className="label">Teléfono principal</span>
            <span className="txt">{c.telefonoPrincipal || "--"}</span>
          </div>

          <div className="card-info">
            <span className="label">Estado</span>
            <span className="txt">{c.estado}</span>
          </div>
        </div>
      </div>
    </div>
  );
};


  // =========================
  // Render Tabs Header
  // =========================
renderTabs = () => {
  const tabs = [
    ["DATOS_PERSONALES", "Datos personales","person"],
    ["TELEFONOS", "Teléfonos", "call"],
    ["CORREOS", "Correos", "mail"],
    ["REDES", "Redes", "share"],
    ["DOCUMENTOS", "Documentos","description"],
    ["ACADEMICOS", "Académicos", "school"],
    ["CAPACITACIONES", "Capacitaciones",  "workspace_premium"],
    ["EXPERIENCIAS", "Experiencias",  "work"],
    ["CARGOS", "Cargos", "work_history"],
    ["EVALUACIONES", "Evaluaciones", "insights"],
    ["DIAS_LABORALES", "Días laborales", "calendar_today"],
  ];

  return (
    <div className="tabs-cards">
      {tabs.map(([key, label, icon]) => (
        <button
          key={key}
          type="button"
          className={`tab-card ${this.state.tab === key ? "active" : ""}`}
          onClick={() => this.setTab(key)}
        >
          <div className="tab-card__content">
            <span className="material-symbols-outlined tab-card__icon">
              {icon}
            </span>

            <span className="tab-card__title">
              {label}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};



  // =========================
  // Render Tab: Datos personales
  // =========================
  renderDatosPersonales = () => {
    const dp = this.state.datosPersonales;

    return (
      <div className="card">
        <h3 className="form-subtitle">Datos personales</h3>

        <div className="form-group__inline">
          <div className="form-group">
            <input type="date" className="form-input" name="fechaNacimiento" value={dp.fechaNacimiento} onChange={this.handleDP} />
            <label className="form-label">Fecha nacimiento</label>
          </div>

          <div className="form-group">
            <input className="form-input" name="sexo" value={dp.sexo} onChange={this.handleDP} />
            <label className="form-label">Sexo</label>
          </div>

          <div className="form-group">
            <input className="form-input" name="estadoCivil" value={dp.estadoCivil} onChange={this.handleDP} />
            <label className="form-label">Estado civil</label>
          </div>

          <div className="form-group">
            <input className="form-input" name="nacionalidad" value={dp.nacionalidad} onChange={this.handleDP} />
            <label className="form-label">Nacionalidad</label>
          </div>
        </div>

        <div className="form-group__inline">
          <div className="form-group">
            <input className="form-input" name="direccion" value={dp.direccion} onChange={this.handleDP} />
            <label className="form-label">Dirección</label>
          </div>

          <div className="form-group">
            <input className="form-input" name="ciudadDireccion" value={dp.ciudadDireccion} onChange={this.handleDP} />
            <label className="form-label">Ciudad</label>
          </div>

          <div className="form-group">
            <input className="form-input" name="paisDireccion" value={dp.paisDireccion} onChange={this.handleDP} />
            <label className="form-label">País</label>
          </div>

          <div className="form-group">
            <input className="form-input" name="codigoInterno" value={dp.codigoInterno} onChange={this.handleDP} />
            <label className="form-label">Código interno</label>
          </div>
        </div>

        <div className="form-group">
          <input type="checkbox" className="form-check" name="esConfidencial" checked={dp.esConfidencial} onChange={this.handleDP} />
          <label className="check-label">Es confidencial</label>
        </div>

        <div className="form-actions">
          <button type="button" className="btn-medium btn-primary" onClick={this.guardarDP} disabled={this.state.guardando}>
            {this.state.guardando ? "Guardando..." : "Guardar datos personales"}
          </button>
        </div>
      </div>
    );
  };

  // =========================
  // Render genérico para tablas simples
  // =========================
  renderSectionTable = ({
    title,
    sectionKey,
    columns,
    emptyFactory,
    handlers,
  }) => {
    const rows = this.state[sectionKey] || [];

    return (
      <div className="card">
        <h3 className="form-subtitle">{title}</h3>

        <div className="table-responsive">
          <table className="table">
<thead>
  <tr>
    {columns.map((c) => <th key={c.key}>{c.label}</th>)}

    {(["documentos", "academicos", "capacitaciones"].includes(sectionKey)) && (
      <>
        <th>Archivo</th>
        <th>Descargar</th>
      </>
    )}

    <th style={{ width: 240 }}>Acciones</th>
  </tr>
</thead>


            <tbody>
              {rows.map((row, idx) => (
                <tr key={row.id ?? `${sectionKey}-${idx}`}>
                  {columns.map((c) => {
                    const val = row?.[c.key];

                    if (c.type === "checkbox") {
                      return (
                        <td key={c.key}>
                          <input
                            type="checkbox"
                            checked={!!val}
                            onChange={(e) => this.updateRowField(sectionKey, idx, c.key, e.target.checked)}
                          />
                        </td>
                      );
                    }

                    if (c.type === "date") {
                      return (
                        <td key={c.key}>
                          <input
                            type="date"
                            className="form-input"
                            value={val ? this.toInputDate(val) : ""}
                            onChange={(e) => this.updateRowField(sectionKey, idx, c.key, e.target.value)}
                          />
                        </td>
                      );
                    }

                    return (
                      <td key={c.key}>
                        <input
                          className="form-input"
                          value={val ?? ""}
                          onChange={(e) => this.updateRowField(sectionKey, idx, c.key, e.target.value)}
                        />
                      </td>
                    );
                  })}

{(() => {
  const hasFiles = ["documentos", "academicos", "capacitaciones"].includes(sectionKey);

  const fileId =
    sectionKey === "documentos" ? row.archivoId :
    sectionKey === "academicos" ? row.certificadoArchivoId :
    sectionKey === "capacitaciones" ? row.certificadoArchivoId :
    null;

  // ✅ si querés mostrar nombre guardado (si tu backend lo trae)
  const savedName = row.nombreArchivo || row.originalName || null;
  const selectedName = row.__file?.name;

  if (!hasFiles) {
    // SOLO acciones cuando no hay archivos
    return (
      <td className="td-actions">
        <button
          type="button"
          className="btn-medium btn-primary"
          onClick={() => this.saveRow(sectionKey, row, handlers)}
          disabled={this.state.guardando}
        >
          {row.id ? "Editar" : "Guardar"}
        </button>

        <button
          type="button"
          className="btn-medium btn-link"
          onClick={() => this.deleteRow(sectionKey, row, handlers)}
          disabled={this.state.guardando}
        >
          Eliminar
        </button>
      </td>
    );
  }

  // ✅ con archivos: Archivo + Descargar + Acciones
  const inputId = `${sectionKey}-file-${idx}`;

  return (
    <>
      <td className="td-file">
        <div className="file-actions">
          <div className="file-stack">
            <input
              id={inputId}
              className="file-input"
              type="file"
              accept="image/*,application/pdf"
              onChange={(e) => this.onSelectArchivo(sectionKey, idx, e.target.files?.[0])}
              disabled={this.state.guardando}
            />

            <label className="file-btn" htmlFor={inputId}>
              <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
                upload
              </span>
              {selectedName ? "Cambiar" : "Subir"}
            </label>

            <div className="file-name">
              {selectedName || savedName || "Sin archivo"}
            </div>
          </div>

          {row.__preview && (
            <img
              src={row.__preview}
              alt="preview"
              className="file-preview"
            />
          )}
        </div>
      </td>

      <td className="td-download">
        {fileId ? (
          <button
            type="button"
            className="btn-medium btn-base-outline"
            onClick={() => this.downloadFile(fileId, savedName || "archivo")}
            disabled={this.state.guardando}
          >
            <span className="material-symbols-outlined" style={{ fontSize: 18, verticalAlign: "middle" }}>
              download
            </span>{" "}
            Descargar
          </button>
        ) : (
          <span style={{ opacity: 0.6 }}>—</span>
        )}
      </td>

      <td className="td-actions">
        <button
          type="button"
          className="btn-medium btn-primary"
          onClick={() => this.saveRow(sectionKey, row, handlers)}
          disabled={this.state.guardando}
        >
          {row.id ? "Editar" : "Guardar"}
        </button>

        <button
          type="button"
          className="btn-medium btn-link"
          onClick={() => this.deleteRow(sectionKey, row, handlers)}
          disabled={this.state.guardando}
        >
          Eliminar
        </button>
      </td>
    </>
  );
})()}


                </tr>
              ))}

              {!rows.length && (
                <tr>
                  <td colSpan={columns.length + (["documentos","academicos","capacitaciones"].includes(sectionKey) ? 3 : 1)}>
                    Sin registros
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-medium btn-base-outline"
            onClick={() => this.addRow(sectionKey, emptyFactory)}
          >
            + Agregar
          </button>
        </div>
      </div>
    );
  };

  // =========================
  // Render por tab (mapeado a tu backend)
  // =========================
  renderContenidoTab = () => {
    const { legajoId } = this.state;

    // handlers por sección conectados a tu service
    const H = {
      telefonos: {
        createFn: this.props.registrarTelefono,
        updateFn: this.props.editarTelefono,
        deleteFn: this.props.eliminarTelefono,
        reloadFn: this.props.getTelefonos,
      },
      correos: {
        createFn: this.props.registrarCorreo,
        updateFn: this.props.editarCorreo,
        deleteFn: this.props.eliminarCorreo,
        reloadFn: this.props.getCorreos,
      },
      redes: {
        createFn: this.props.registrarRed,
        updateFn: this.props.editarRed,
        deleteFn: this.props.eliminarRed,
        reloadFn: this.props.getRedes,
      },
      documentos: {
        createFn: this.props.registrarDocumento,
        updateFn: this.props.editarDocumento,
        deleteFn: this.props.eliminarDocumento,
        reloadFn: this.props.getDocumentos,
      },
      academicos: {
        createFn: this.props.registrarAcademico,
        updateFn: this.props.editarAcademico,
        deleteFn: this.props.eliminarAcademico,
        reloadFn: this.props.getAcademicos,
      },
      capacitaciones: {
        createFn: this.props.registrarCapacitacion,
        updateFn: this.props.editarCapacitacion,
        deleteFn: this.props.eliminarCapacitacion,
        reloadFn: this.props.getCapacitaciones,
      },
      experiencias: {
        createFn: this.props.registrarExperiencia,
        updateFn: this.props.editarExperiencia,
        deleteFn: this.props.eliminarExperiencia,
        reloadFn: this.props.getExperiencias,
      },
      cargos: {
        createFn: this.props.registrarCargo,
        updateFn: this.props.editarCargo,
        deleteFn: this.props.eliminarCargo,
        reloadFn: this.props.getCargos,
      },
      evaluaciones: {
        createFn: this.props.registrarEvaluacion,
        updateFn: this.props.editarEvaluacion,
        deleteFn: this.props.eliminarEvaluacion,
        reloadFn: this.props.getEvaluaciones,
      },
    };

    switch (this.state.tab) {
      case "DATOS_PERSONALES":
        return this.renderDatosPersonales();

      case "TELEFONOS":
        return this.renderSectionTable({
          title: "Teléfonos",
          sectionKey: "telefonos",
          emptyFactory: () => ({ tipo: "CELULAR", numero: "", principal: false, activo: true }),
          handlers: H.telefonos,
          columns: [
            { key: "tipo", label: "Tipo" },
            { key: "numero", label: "Número" },
            { key: "principal", label: "Principal", type: "checkbox" },
          ],
        });

      case "CORREOS":
        return this.renderSectionTable({
          title: "Correos",
          sectionKey: "correos",
          emptyFactory: () => ({ email: "", principal: false, activo: true }),
          handlers: H.correos,
          columns: [
            { key: "email", label: "Email" },
            { key: "principal", label: "Principal", type: "checkbox" },
          ],
        });

      case "REDES":
        return this.renderSectionTable({
          title: "Redes sociales",
          sectionKey: "redes",
          emptyFactory: () => ({ tipo: "", url: "", activo: true }),
          handlers: H.redes,
          columns: [
            { key: "tipo", label: "Tipo" },
            { key: "url", label: "URL" },
          ],
        });

      case "DOCUMENTOS":
        return this.renderSectionTable({
          title: "Documentos personales",
          sectionKey: "documentos",
          emptyFactory: () => ({ tipoDocumento: "", numeroDocumento: "", archivoId: "", observaciones: "", activo: true }),
          handlers: H.documentos,
          columns: [
            { key: "tipoDocumento", label: "Tipo" },
            { key: "numeroDocumento", label: "Número" },
            { key: "observaciones", label: "Observaciones" },
          ],
        });

      case "ACADEMICOS":
        return this.renderSectionTable({
          title: "Registros académicos",
          sectionKey: "academicos",
          emptyFactory: () => ({
            tipo: "", institucion: "", carrera: "", aniosCursados: "", tituloObtenido: "",
            pesoExportacion: "", certificadoArchivoId: "", observaciones: "", activo: true
          }),
          handlers: H.academicos,
          columns: [
            { key: "tipo", label: "Tipo" },
            { key: "institucion", label: "Institución" },
            { key: "carrera", label: "Carrera" },
            { key: "aniosCursados", label: "Años cursados" },
            { key: "tituloObtenido", label: "Título" }
          ],
        });

      case "CAPACITACIONES":
        return this.renderSectionTable({
          title: "Capacitaciones",
          sectionKey: "capacitaciones",
          emptyFactory: () => ({
            institucion: "", nombre: "", anio: "", pesoExportacion: "",
            certificadoArchivoId: "", observaciones: "", capacitacionRefId: "", activo: true
          }),
          handlers: H.capacitaciones,
          columns: [
            { key: "institucion", label: "Institución" },
            { key: "nombre", label: "Nombre" },
            { key: "anio", label: "Año" },
            { key: "capacitacionRefId", label: "Ref ID" },
          ],
        });

      case "EXPERIENCIAS":
        return this.renderSectionTable({
          title: "Experiencias",
          sectionKey: "experiencias",
          emptyFactory: () => ({
            cliente: "", nombreProyecto: "", anio: "", cargo: "",
            duracionHs: "", duracionDias: "", duracionMeses: "", descripcion: "", activo: true
          }),
          handlers: H.experiencias,
          columns: [
            { key: "cliente", label: "Cliente" },
            { key: "nombreProyecto", label: "Proyecto" },
            { key: "anio", label: "Año" },
            { key: "cargo", label: "Cargo" },
            { key: "duracionHs", label: "Hs" },
            { key: "duracionDias", label: "Días" },
            { key: "duracionMeses", label: "Meses" },
          ],
        });

      case "CARGOS":
        return this.renderSectionTable({
          title: "Historial de cargos",
          sectionKey: "cargos",
          emptyFactory: () => ({ nombreCargo: "", fechaInicio: "", fechaFin: "", activo: true }),
          handlers: H.cargos,
          columns: [
            { key: "nombreCargo", label: "Cargo" },
            { key: "fechaInicio", label: "Inicio", type: "date" },
            { key: "fechaFin", label: "Fin", type: "date" },
          ],
        });

      case "EVALUACIONES":
        return this.renderSectionTable({
          title: "Evaluaciones",
          sectionKey: "evaluaciones",
          emptyFactory: () => ({ evaluacionId: "", fecha: "", resultado: "", activo: true }),
          handlers: H.evaluaciones,
          columns: [
            { key: "evaluacionId", label: "Evaluación ID" },
            { key: "fecha", label: "Fecha", type: "date" },
            { key: "resultado", label: "Resultado" },
          ],
        });

      case "DIAS_LABORALES":
        return this.renderDiasLaborales();

      default:
        return null;
    }
  };

  // =========================
  // Días laborales
  // =========================

  DIAS_SEMANA = [
    { label: "Lunes",     bit: 1   },
    { label: "Martes",    bit: 2   },
    { label: "Miércoles", bit: 4   },
    { label: "Jueves",    bit: 8   },
    { label: "Viernes",   bit: 16  },
    { label: "Sábado",    bit: 32  },
    { label: "Domingo",   bit: 64  },
  ];

  toggleDia = (bit) => {
    this.setState(prev => ({
      diasLaboralesMask: prev.diasLaboralesMask ^ bit
    }));
  };

  guardarDiasLaborales = async () => {
    const { legajoId, diasLaboralesMask } = this.state;
    try {
      this.setState({ guardando: true });
      await setDiasLaborales(legajoId, diasLaboralesMask);
      this.flash("Días laborales guardados correctamente", "exito");
    } catch (e) {
      this.flash("Error al guardar los días laborales", "error");
    } finally {
      this.setState({ guardando: false });
    }
  };

  renderDiasLaborales = () => {
    const { diasLaboralesMask, guardando } = this.state;
    return (
      <div className="card">
        <h3 className="form-subtitle">Días laborales</h3>
        <p style={{ marginBottom: 16, color: "#666" }}>
          Seleccioná los días de la semana que trabaja este colaborador. Se usarán para calcular los días hábiles en solicitudes de vacaciones.
        </p>
        <div className="inline-group" style={{ marginBottom: 24 }}>
          {this.DIAS_SEMANA.map(({ label, bit }) => {
            const activo = (diasLaboralesMask & bit) !== 0;
            return (
              <div className="form-group" key={bit}>
                <input
                  type="checkbox"
                  className="form-check"
                  id={`dia-${bit}`}
                  checked={activo}
                  onChange={() => this.toggleDia(bit)}
                />
                <label htmlFor={`dia-${bit}`} className="check-label">
                  {label}
                </label>
              </div>
            );
          })}
        </div>
        <div className="form-actions">
          <button
            className="btn-medium btn-primary"
            onClick={this.guardarDiasLaborales}
            disabled={guardando || diasLaboralesMask === 0}
          >
            Guardar
          </button>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.cargando) {
      return <PantallaCarga mensaje="Cargando legajo..." />;
    }

    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={"/administracion/legajos"}
              breadcrumbs={[
                { label: "Administración", path: "/administracion/legajos" },
                { label: "Legajos", path: "/administracion/legajos" },
                { label: "Editar legajo", path: "" },
              ]}
            />

            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">Editar legajo</h1>
                <p className="page-description">
                  Edite datos personales y secciones del legajo (teléfonos, correos, etc.)
                </p>
              </div>

              <div className="head-actions">
                <button
                  onClick={this.cargarTodo}
                  className="btn-medium btn-base-outline"
                  disabled={this.state.guardando}
                >
                  Descargar Legajo
                </button>
              </div>
            </div>
          </div>
        </header>

        <div className="wrapperContent">
          <div className="page-container">
            {this.renderCabecera()}

            {this.renderTabs()}

            <div style={{ marginTop: 12 }}>
              {this.renderContenidoTab()}
            </div>
          </div>
        </div>

        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity}
        />

        <PantallaCarga visible={this.state.guardando} mensaje="Procesando..." />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  obtenerCabeceraLegajo: (id) => dispatch(obtenerCabeceraLegajo(id)),
  obtenerDatosPersonales: (id) => dispatch(obtenerDatosPersonales(id)),
  guardarDatosPersonales: (id, dto) => dispatch(guardarDatosPersonales(id, dto)),

  getTelefonos: (id) => dispatch(getTelefonos(id)),
  registrarTelefono: (id, dto) => dispatch(registrarTelefono(id, dto)),
  editarTelefono: (id, rowId, dto) => dispatch(editarTelefono(id, rowId, dto)),
  eliminarTelefono: (id, rowId) => dispatch(eliminarTelefono(id, rowId)),

  getCorreos: (id) => dispatch(getCorreos(id)),
  registrarCorreo: (id, dto) => dispatch(registrarCorreo(id, dto)),
  editarCorreo: (id, rowId, dto) => dispatch(editarCorreo(id, rowId, dto)),
  eliminarCorreo: (id, rowId) => dispatch(eliminarCorreo(id, rowId)),

  getRedes: (id) => dispatch(getRedes(id)),
  registrarRed: (id, dto) => dispatch(registrarRed(id, dto)),
  editarRed: (id, rowId, dto) => dispatch(editarRed(id, rowId, dto)),
  eliminarRed: (id, rowId) => dispatch(eliminarRed(id, rowId)),

  getDocumentos: (id) => dispatch(getDocumentos(id)),
  registrarDocumento: (id, dto, esMultipart) => dispatch(registrarDocumento(id, dto, esMultipart)),
  editarDocumento: (id, rowId, dto, esMultipart) => dispatch(editarDocumento(id, rowId, dto, esMultipart)),
  eliminarDocumento: (id, rowId) => dispatch(eliminarDocumento(id, rowId)),

  getAcademicos: (id) => dispatch(getAcademicos(id)),
  registrarAcademico: (id, dto) => dispatch(registrarAcademico(id, dto)),
  editarAcademico: (id, rowId, dto) => dispatch(editarAcademico(id, rowId, dto)),
  eliminarAcademico: (id, rowId) => dispatch(eliminarAcademico(id, rowId)),

  getCapacitaciones: (id) => dispatch(getCapacitaciones(id)),
  registrarCapacitacion: (id, dto) => dispatch(registrarCapacitacion(id, dto)),
  editarCapacitacion: (id, rowId, dto) => dispatch(editarCapacitacion(id, rowId, dto)),
  eliminarCapacitacion: (id, rowId) => dispatch(eliminarCapacitacion(id, rowId)),

  getExperiencias: (id) => dispatch(getExperiencias(id)),
  registrarExperiencia: (id, dto) => dispatch(registrarExperiencia(id, dto)),
  editarExperiencia: (id, rowId, dto) => dispatch(editarExperiencia(id, rowId, dto)),
  eliminarExperiencia: (id, rowId) => dispatch(eliminarExperiencia(id, rowId)),

  getCargos: (id) => dispatch(getCargos(id)),
  registrarCargo: (id, dto) => dispatch(registrarCargo(id, dto)),
  editarCargo: (id, rowId, dto) => dispatch(editarCargo(id, rowId, dto)),
  eliminarCargo: (id, rowId) => dispatch(eliminarCargo(id, rowId)),

  getEvaluaciones: (id) => dispatch(getEvaluaciones(id)),
  registrarEvaluacion: (id, dto) => dispatch(registrarEvaluacion(id, dto)),
  editarEvaluacion: (id, rowId, dto) => dispatch(editarEvaluacion(id, rowId, dto)),
  eliminarEvaluacion: (id, rowId) => dispatch(eliminarEvaluacion(id, rowId)),
  descargarLegajoFile: (fileId) => descargarLegajoFile(fileId),
});

export default connect(null, mapDispatchToProps)(EditarLegajo);
